module.exports = __webpack_public_path__ + "static/media/EmptyUpdatesNew.ba96fe5d.png";